import { gql } from 'graphql-request';
import { get, put } from '@elementary/common-ui/utils/http';

export const getDataHealthDashboardQuery = gql`
  query GetDataHealthDashboard(
    $daysBack: Int!
    $filters: [Filter!]
    $assetIds: [String!]
  ) {
    dataHealthDashboard(
      daysBack: $daysBack
      filters: $filters
      assetIds: $assetIds
    ) {
      totalScore {
        percent
        value
        thresholds {
          low
          medium
        }
      }
      tests {
        total
      }
      scoreOverTime {
        date
        score
      }
      qualityDimensions {
        dimension
        score {
          percent
          value
          thresholds {
            low
            medium
          }
        }
        tests {
          total
        }
        tables {
          monitored
        }
        scoreOverTime {
          date
          score
        }
      }
    }
  }
`;

export const fetchDataHealthTotalFormula = async (
  envId: string,
): Promise<{
  thresholds: { low: number; medium: number };
  weights: Record<string, number>;
}> =>
  get(
    `${import.meta.env.VITE_API_BASE_URL}/${envId}/data-health/total-formula`,
  );

export const fetchQualityDimensionThresholds = async (
  envId: string,
  qualityDimension: string,
): Promise<{ low: number; medium: number }> =>
  get(
    `${
      import.meta.env.VITE_API_BASE_URL
    }/${envId}/data-health/quality-thresholds/${qualityDimension}`,
  );

export const updateDimensionFormula = async (
  envId: string,
  weights: Record<string, number>,
  low: number,
  medium: number,
) => {
  await put(
    `${import.meta.env.VITE_API_BASE_URL}/${envId}/data-health/total-formula`,
    { weights, thresholds: { low, medium } },
  );
};

export const updateQualityDimensionThresholds = async (
  envId: string,
  qualityDimension: string,
  low: number,
  medium: number,
) => {
  await put(
    `${
      import.meta.env.VITE_API_BASE_URL
    }/${envId}/data-health/quality-thresholds/${qualityDimension}`,
    { low, medium },
  );
};
